import type { ServerConfig } from "@heydex/contracts";

/** Keep the server's disk layout out of labels and file-transfer URLs. */
export function hostedPathLabel(
  path: string,
  config: Pick<ServerConfig, "newProjectsRoot"> | null | undefined,
): string {
  if (!config) return path;
  if (path === "/workspace" || path.startsWith("/workspace/")) return path;
  const root = config.newProjectsRoot?.replace(/\/+$/, "");
  if (root && path === root) return "/workspace";
  if (root && path.startsWith(`${root}/`)) return `/workspace/${path.slice(root.length + 1)}`;
  if (!path.startsWith("/")) return path;
  return "HeyDex files";
}
